'use client';

import { Container } from '@/src/components/container';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { useDomReady } from '@/src/hooks/dom-ready';
import { CertificateModelSectionProps } from '..';
import { CertificateCardModel } from '@/src/components/cards/banner-images/certificate';

SwiperCore.use([Autoplay, Pagination]);

export function CertificateCardsCaraousl({
   cards,
}: Pick<CertificateModelSectionProps, 'cards'>) {
   const isDomReady = useDomReady();

   return (
      <>
         {isDomReady && (
            <Container>
               {cards && cards.length > 0 && (
                  <div className="m-[60px]">
                     <Swiper

                        className="!overflow-visible"
                        speed={400}
                        loop
                        spaceBetween={30}
                        slidesPerView={3}
                        breakpoints={{
                           0: {
                              spaceBetween: 30,
                              slidesPerView: 1,
                           },
                           375: {
                              spaceBetween: 30,
                              slidesPerView: 1,
                           },
                           575: {
                              spaceBetween: 30,
                              slidesPerView: 1,
                           },
                           768: {
                              spaceBetween: 30,
                              slidesPerView: 2,
                           },
                           992: {
                              spaceBetween: 30,
                              slidesPerView: 2,
                           },
                           1200: {
                              spaceBetween: 30,
                              slidesPerView: 3,
                           },
                        }}
                        pagination={{
                           clickable: true,
                           dynamicBullets: true,
                           type: 'bullets', // 'bullets', 'fraction', 'progressbar', or 'custom'
                           el: '.swiper-pagination',
                        }}
                     >
                        {cards.map((card, i) => (
                           <SwiperSlide key={i}>
                              <CertificateCardModel {...card} />
                           </SwiperSlide>
                        ))}
                     </Swiper>
                     <div className="swiper-pagination absolute bottom-0"></div>
                  </div>
               )}
            </Container>
         )}
      </>
   );
}
